export default "__VITE_ASSET__Bbcw1TNa__"